import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ContentPagesComponent } from './content-pages.component';
import { ContentRecordsComponent } from './content-records.component';
import { AuthGuard } from '../shared/auth-gard.service';

import { AdminLoginComponent } from './admin-login.component';
import { AdminRootComponent } from './admin-root.component'; 
import { ContentPageEditComponent } from './content-page-edit.component';
import { ContentRecordEditComponent } from './content-record-edit.component';
import { ContentSpecialEditComponent } from './content-special-edit.component';
import { ContentSpecialsComponent } from './content-specials.component';
import { ContentWritingEditComponent } from './content-writing-edit.component';
import { ContentWritingsComponent } from './content-writings.component';
import { ContentMessagesComponent } from './content-messages.component';
import { ContentMessageEditComponent } from './content-message-edit.component';

const contentRoutes: Routes = [ 
    // HOME 
    { path: '', redirectTo: 'records', pathMatch: 'full'},
    // PAGE  
    { path: 'pages',  component: ContentPagesComponent },
    /*fake reload*/{ path: 'pages/reload',  component: ContentPagesComponent },
    { path: 'page/edit/:id',  component: ContentPageEditComponent },
    // RECORD 
    { path: 'records',  component: ContentRecordsComponent },
    { path: 'records/active/:active',  component: ContentRecordsComponent },
    /*fake reload*/{ path: 'records/reload',  component: ContentRecordsComponent },
    { path: 'record/edit/:id',  component: ContentRecordEditComponent },
    // SPECIAL
    { path: 'specials',  component: ContentSpecialsComponent },
    /*fake reload*/{ path: 'specials/reload',  component: ContentSpecialsComponent },
    { path: 'special/edit/:id',  component: ContentSpecialEditComponent },
    // WRITING
    { path: 'writings',  component: ContentWritingsComponent },
    /*fake reload*/{ path: 'writings/reload',  component: ContentWritingsComponent },
    { path: 'writing/edit/:id',  component: ContentWritingEditComponent },
    // MESSAGE
    { path: 'messages',  component: ContentMessagesComponent },
    /*fake reload*/{ path: 'messages/reload',  component: ContentMessagesComponent },
    { path: 'message/edit/:id',  component: ContentMessageEditComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild([
    { path: 'admin/login',  component: AdminLoginComponent },
    // , canActivateChild: [AuthGuard],
    { path: 'admin',  component: AdminRootComponent, children: contentRoutes, canActivateChild: [AuthGuard] },
    // , canActivateChild: [AuthGuard],
    { path: ':lg/admin',  component: AdminRootComponent, children: contentRoutes, canActivateChild: [AuthGuard] }
    ])
  ]
  //exports: [ RouterModule ]
})
export class AdminRoutingModule {
  constructor(){}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-routing.module.ts